import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { ScriptLoaderService } from '@src/app/shared/services/script-loader.service';

@Component({
    selector: 'matrix-empty-layout',
    templateUrl: './empty-layout.component.html',
    styleUrls: ['./empty-layout.component.scss'],
    imports: [CommonModule, RouterOutlet],
})
export class EmptyLayoutComponent {
    constructor(private scriptLoader: ScriptLoaderService) {
        this.scriptLoader.init();
    }
}
